import React from "react";

import "../Styles/Modal.css";
import EditProtocols from "./EditProtocols";

export default function ModalEditProtocol({
  setEditModalProtocol,
  infoProtocolEdit,
}) {
  return (
    <div className="Modal">
      <div className="Modal__Container" style={{"top":"75px"}}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Editar Protocolo
              </h5>
              <button
                onClick={() => setEditModalProtocol(false)}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <EditProtocols infoProtocolEdit={infoProtocolEdit} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
